"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const actions_1 = require("../../../../actions/");
const reducers_1 = require("../../../../reducers/");
const RichMediaUpdateButtons = ({ activePopover, deliverable, device, updateNotificationDeliverable, updateTempNotificationAttachmentFields }) => {
    const { attachment } = deliverable;
    if (device === 'Tablet' && !attachment) {
        return React.createElement(src_1.PlusIcon, { fill: src_1.titanium });
    }
    if (activePopover !== 'notification-attachment-picker' && device !== 'Desktop' && attachment) {
        return (React.createElement(src_1.CircleCloseIcon, { fill: src_1.turquoise, onClick: (e) => {
                e.stopPropagation();
                updateNotificationDeliverable({ attachment: null });
                updateTempNotificationAttachmentFields({
                    type: 'IMAGE',
                    url: '',
                });
            } }));
    }
    if (device === 'Desktop' && !attachment) {
        return (React.createElement(src_1.Button, { text: "Add", type: "regular", style: {
                innerStyle: {
                    fontSize: 17,
                },
            }, mouseDownColors: {
                active: src_1.turquoise,
                inactive: src_1.aquamarine,
            } }));
    }
    if (device === 'Desktop' && attachment) {
        return (React.createElement("div", { style: { display: 'flex' } },
            React.createElement(src_1.Button, { onClick: () => {
                    updateNotificationDeliverable({
                        attachment: null,
                    });
                    updateTempNotificationAttachmentFields({
                        type: 'IMAGE',
                        url: '',
                    });
                }, text: "Remove", type: "regular", style: {
                    innerStyle: {
                        fontSize: 17,
                        marginRight: 8,
                    },
                }, mouseDownColors: {
                    active: src_1.turquoise,
                    inactive: src_1.aquamarine,
                } }),
            React.createElement(src_1.Button, { text: "Edit", type: "regular", style: {
                    innerStyle: {
                        fontSize: 17,
                    },
                }, mouseDownColors: {
                    active: src_1.turquoise,
                    inactive: src_1.aquamarine,
                } })));
    }
    return React.createElement("div", null);
};
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    deliverable: reducers_1.getEditableCampaignDeliverable(state),
    editableUIState: reducers_1.getEditableUIState(state),
});
const mapDispatchToProps = (dispatch) => ({
    updateNotificationDeliverable: (d) => dispatch(actions_1.updateNotificationDeliverable(d)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RichMediaUpdateButtons);
